<template>
  <!--
    Use this for each page's main title, equivalent to h1. Has the option for some small text above and below the large text.
  -->
  <div role="heading" aria-level="1" id="page-title">
    <div id="page-supertitle" v-if="supertitle">
      {{ supertitle }}
    </div>
    <div>
      {{ title }}
    </div>
    <div id="page-subtitle" v-if="subtitle">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: { type: String, required: true },
    supertitle: { type: String, required: false },
    subtitle: { type: String, required: false }
  },
}
</script>

<style lang="scss">
@import '@/scss/vars.scss';
#page-title {
  font-weight: 200;
  color: #5a5a5a;
  font-size: 3.5rem;
  text-align: center;
  font-family: 'Work Sans', sans-serif;
  margin-bottom: 1rem;
  margin-top: 1rem;

  #page-supertitle, #page-subtitle {
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 400;
    display: block;
    color: #737373;
  }

  #page-supertitle {
    margin-bottom: -0.5rem;
  }

  #page-subtitle {
    margin-top: -0.25rem;
  }
}
@media screen and (max-width: $tablet) {
  #page-title {
    font-size: 2.5rem;
  }
}
</style>
